import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSettingsQuery } from 'src/api/queries/userQueries';
import { Loader } from 'src/components';

const SettingsRedirect: React.FC = () => {
  const { isLoading, data, isError } = useSettingsQuery();
  
  // Show loading spinner while fetching settings
  if (isLoading) {
    return <Loader />;
  }
  
  // If there's an error or no data, redirect to security as fallback
  if (isError || !data) {
    return <Redirect to="/admin/settings/security" />;
  }
  
  // If storage_provider is not 'r2', redirect to storage (original behavior)
  // Otherwise, redirect to security (first available tab)
  const redirectTo = data?.storage?.storage_provider !== 'r2' 
    ? '/admin/settings/storage' 
    : '/admin/settings/security';
    
  return <Redirect to={redirectTo} />;
};

export default SettingsRedirect;
